import { gql } from 'graphql-tag';

export const LOCATION_QUERY = gql`
  query LocationQuery($type: String, $slug: String) {
    locationInfo: location(locationType: $type, locationSlug: $slug) {
      id
      name
      locationBlurb
    }
  }
`;

export interface LocationQueryResponse {
  locationInfo: LocationInfo;
}

export interface LocationQueryRequest {
  type?: string;
  slug?: string;
}

export type LocationInfo = {
  id: number;
  name: string;
  locationBlurb: string;
};
